/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import React from "react";
import styles from "gui/footer/footer.module.css";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Page } from "gui/page/page";
import { SessionContext } from "gui/session/session";
import { Spacer } from "gui/spacer/spacer";
import { TimeRelative } from "gui/time/time";
import { useLoginUrl } from "lib/hooks/useLoginUrl";

export const Footer: React.FC<{
  timestamp?: string;
}> = (props) => {
  const { session } = React.useContext(SessionContext);
  const loginUrl = useLoginUrl();

  return (
    <Page as="footer" size="md">
      <Spacer size="lg" />
      <Grid as="div" className={styles.footer} gaps>
        <article>
          <p>&copy; Dune {year}</p>
          <ul>
            <li>
              <Link href="/home">
                <a>
                  <Icon icon="home" />
                  Home page
                </a>
              </Link>
            </li>
            {!session && (
              <li>
                <a href={loginUrl}>
                  <Icon icon="person" />
                  Sign in
                </a>
              </li>
            )}
            {props.timestamp && (
              <li>
                <Icon icon="clock" aria-label="Updated" />
                <TimeRelative>{props.timestamp}</TimeRelative>
              </li>
            )}
          </ul>
        </article>
        <article>
          <p>Information</p>
          <ul>
            <li>
              <Link href="/projects">
                <a>
                  <Icon icon="dashboard" />
                  Projects
                </a>
              </Link>
            </li>
            <li>
              <Link href="/pricing">
                <a>
                  <Icon icon="star" />
                  Subscriptions
                </a>
              </Link>
            </li>
            <li>
              <Link href="/blog">
                <a>
                  <Icon icon="chat" />
                  Blog
                </a>
              </Link>
            </li>
            <li>
              <a href="/docs" target="_blank">
                <Icon icon="bookmark" />
                Docs
              </a>
            </li>
          </ul>
        </article>
        <article>
          <p>Get in touch</p>
          <ul>
            <li>
              <a href="mailto:support@dune.com">
                <Icon icon="mail" />
                Email
              </a>
            </li>
            <li>
              <a href="https://twitter.com/DuneAnalytics">
                <Icon icon="egg" />
                Twitter
              </a>
            </li>
            <li>
              <a href="https://discord.gg/ErrzwBz">
                <Icon icon="discord" />
                Discord
              </a>
            </li>
            <li>
              <a href="https://github.com/duneanalytics">
                <Icon icon="terminal" />
                GitHub
              </a>
            </li>
            <li>
              <a href="/careers">
                <Icon icon="building" />
                Careers
              </a>
            </li>
          </ul>
        </article>
        <article>
          <p>The fine print</p>
          <ul>
            <li>
              <Link href="/terms">
                <a>
                  <Icon icon="text" />
                  Terms of Service
                </a>
              </Link>
            </li>
            <li>
              <Link href="/privacy">
                <a>
                  <Icon icon="shield" />
                  Privacy Policy
                </a>
              </Link>
            </li>
          </ul>
        </article>
      </Grid>
      <Spacer size="lg" />
    </Page>
  );
};

const year = new Date().getFullYear();
